// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sunzi__loading-animation-P3Ubl {
  display: flex;
  width: 135px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/RecognitionLoading/style.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,YAAA;AACF","sourcesContent":[".loading-animation {\n  display: flex;\n  width: 135px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loading-animation": `sunzi__loading-animation-P3Ubl`,
	"loadingAnimation": `sunzi__loading-animation-P3Ubl`
};
export default ___CSS_LOADER_EXPORT___;
